<template>
    <div class="count-warp">
        <div class="item" v-for="(i,k) in items" :key="k">
            <div class="label">{{i.name}}</div>
            <div class="value">{{i.value}}</div>
            <!-- <dv-digital-flop :config="i.config" style="height:40px;" /> -->
        </div>
    </div>
</template>

<script>
    import {
        UserStore
    } from '@/utils/Mixin'
    export default {
        mixins: [UserStore],
        data() {
            return {
                list: [{
                        name: '在线设备',
                        value: 0,
                        key: 'num1'
                    },
                    {
                        name: '设备总数',
                        value: 0,
                        key: 'num2'
                    },
                    {
                        name: '运行设备',
                        value: 0,
                        key: 'num3'
                    },
                    {
                        name: '运行设备',
                        value: 0,
                        key: 'num3'
                    }
                ]
            }
        },
        computed: {
            items() {
                let Data = {
                    num1: 0,
                    num2: 0,
                    num3: 0
                }

                if (this.Data && this.Data.data0) {
                    Data = Object.assign(Data, this.Data.data0)
                }

                let list = this.list.map(i => {
                    let value = Data.hasOwnProperty(i.key) ? parseInt(Data[i.key]) : 0

                    const config = {
                        number: [value],
                        content: '{nt}',
                        formatter: this.formatter,
                        style: {
                            fontSize: 40,
                            fill: '#ef9d27',
                            fontWeight: 'bold',
                            fontFamily: 'MyriadPro-Regular'
                        }
                    }

                    return {
                        ...i,
                        value,
                        config
                    }
                })

                return list
            }
        },
        methods: {
            formatter(number) {
                const numbers = number.toString().split('').reverse()
                const segs = []

                while (numbers.length) segs.push(numbers.splice(0, 3).join(''))

                return segs.join(',').split('').reverse().join('')
            }
        }
    }
</script>

<style lang="less" scoped>
    .count-warp {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-bottom: 36px;
            width: 258px;
            height: 152px;
            background-image: url("/static/images/home/count/bg.png");
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;

            &:last-child {
                margin-bottom: 0;
            }

            .label {
                margin-bottom: 24px;
                line-height: 1;
                font-size: 20px;
                letter-spacing: 1px;
                color: #ffffff;
                font-weight: bold;
            }

            .value {
                line-height: 1;
                font-size: 40px;
                letter-spacing: 2px;
                color: #ef9d27;
                font-weight: bold;
            }
        }
    }
</style>
